import React from 'react';
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { FaChartBar } from 'react-icons/fa';
import styles from './CampaignCard.module.scss';

const CampaignCard = ({ title, startDate, endDate, active, setIsActive }) => {
    return (
        <Container fluid className={styles.card}>
            <Row className="g-0">
                <Col>
                    <h5>{title}</h5>
                    <p>Start date: {startDate}</p>
                    <p>End date: {endDate}</p>
                </Col>
                <Col>
                    <div className={styles.controls}>
                        <Form>
                            <FormGroup switch>
                                <Input
                                    type="switch"
                                    role="switch"
                                    checked={active}
                                    onClick={() => { setIsActive(!active) }}
                                    className={styles.customSwitch}
                                />
                                <Label for="customSwitch" check />
                            </FormGroup>
                        </Form>
                        <button type="button" className={styles.editBtn}>Edit</button>
                        <FaChartBar size={20} className={styles.icons} />
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default CampaignCard;
